import React, { useContext, useMemo } from 'react'
import { AvailSection } from '../../styles'
import { PlayersOnTeam, PositionNames } from '../../../../Api'
import { PlayerItem } from './PlayerItem'
import { AllStarContext } from '../../../../Context'
import { getAllStarPositionCode } from '../../../../Utils'
import { mergePosition } from '../../../../Utils/AllStar/allStarHelper'

type AllStarPlayerListParams = {
  position: PositionNames
  isSelected: (player: PlayersOnTeam) => boolean
}

export const PlayerList: React.FC<React.PropsWithChildren<AllStarPlayerListParams>> = ({
  position,
  isSelected,
}) => {
  const { availablePlayers, playerType } = useContext(AllStarContext)!

  const players = useMemo(() => {
    if (availablePlayers.length < 1) return []
    const aps = availablePlayers.filter(
      (pl) =>
        pl.currentTeam?.conference === (playerType === 'east' ? 'eastern' : 'western') &&
      mergePosition(pl.currentTeam?.position) === getAllStarPositionCode(position)
    )
    return aps
  }, [availablePlayers, playerType, position])

  return (
    <AvailSection>
      {players.length > 0 && (
        <div className="availablePlayersCon">
          {players.map((player) => (
            <PlayerItem
              key={player.officialId}
              player={player}
              isSelected={isSelected}
            />
          ))}
        </div>
      )}
    </AvailSection>
  )
}
